import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const update_purchase_status = (orderNo, hasSentPurchase) => {
  return api.post(`${ApiEndpointConstants.UPDATEPURCHASESTATUS}`, {
    orderNo,
    hasSentPurchase,
  });
};
